import React from "react";

function StepEleven({ formData, onNext, isSubmitting }) {
    const isCurrentlySubmitting = isSubmitting;
    console.log(isCurrentlySubmitting);

    const renderField = (label, value) => (
        <div className="mb-2">
            <strong>{label}:</strong> {value ? value.toString() : "—"}
        </div>
    );

    const renderSection = (title, fields) => (
        <div className="mb-4">
            <h6 className="mb-3 border-bottom pb-2">{title}</h6>
            {fields}
        </div>
    );

    return (
        <div className="step-form">
            <h6 className="mb-4">Review Your Health Questionnaire</h6>

            <div className="bg-light p-4 rounded border">
                {/* Personal Information Section */}
                {renderSection(
                    "Personal Information",
                    <>
                        {renderField("Full Name", formData.fullName)}
                        {renderField("Date of Birth", formData.dob)}
                        {renderField("Job Title", formData.jobTitle)}
                        {renderField("Proposed Start Date", formData.startDate)}
                        {renderField("Contact Number", formData.contactNumber)}
                    </>
                )}

                {/* Medical Health Declaration Section */}
                {renderSection(
                    "Medical Health Declaration",
                    <>
                        {renderField(
                            "Current or Past Medical Conditions",
                            formData.hasMedicalCondition === "yes" ? "Yes" : "No"
                        )}
                        {formData.hasMedicalCondition === "yes" && 
                            renderField("Medical Condition Details", formData.medicalDetails)
                        }
                        
                        {renderField(
                            "Currently Taking Medication",
                            formData.takesMedication === "yes" ? "Yes" : "No"
                        )}
                        {formData.takesMedication === "yes" && 
                            renderField("Medication Details", formData.medicationDetails)
                        }
                        
                        {renderField(
                            "Hospital Visits in Last 12 Months",
                            formData.hadHospitalVisit === "yes" ? "Yes" : "No"
                        )}
                        {formData.hadHospitalVisit === "yes" && 
                            renderField("Hospital Visit Details", formData.hospitalDetails)
                        }
                        
                        {formData.conditions && formData.conditions.length > 0 && (
                            renderField("Specific Health Conditions", formData.conditions.join(", "))
                        )}
                        
                        {formData.otherCondition && 
                            renderField("Other Health Conditions", formData.otherCondition)
                        }
                    </>
                )}

                {/* Work Capacity Section */}
                {renderSection(
                    "Work Capacity & Limitations",
                    <>
                        {renderField(
                            "Work Limiting Condition",
                            formData.hasWorkLimitingCondition === "yes" ? "Yes" : "No"
                        )}
                        {formData.hasWorkLimitingCondition === "yes" && 
                            renderField("Work Limiting Condition Details", formData.workConditionDetails)
                        }
                    </>
                )}

                {/* Vaccination History Section */}
                {renderSection(
                    "Vaccination History",
                    <>
                        {formData.vaccinations && formData.vaccinations.length > 0 ? (
                            <div className="mb-2">
                                <strong>Vaccinations Received:</strong> {formData.vaccinations.join(", ")}
                            </div>
                        ) : (
                            <div className="mb-2">—</div>
                        )}
                        
                        {formData.otherVaccination && 
                            renderField("Other Vaccinations", formData.otherVaccination)
                        }
                    </>
                )}

                {/* Workplace Adjustments Section */}
                {renderSection(
                    "Workplace Adjustments",
                    <>
                        {renderField(
                            "Requires Workplace Adjustments",
                            formData.needsAdjustment === "yes" ? "Yes" : "No"
                        )}
                        {formData.needsAdjustment === "yes" && 
                            renderField("Adjustment Requirements", formData.adjustmentDetails)
                        }
                    </>
                )}

                {/* Employee Declaration Section */}
                {renderSection(
                    "Employee Declaration",
                    <>
                        {renderField("Signature", formData.declareSignature)}
                        {renderField("Declaration Date", formData.declareDate)}
                    </>
                )}

            </div>

            <div className="alert alert-info mt-4">
                <strong>Please review all health information carefully.</strong> This information 
                will be handled confidentially by our Occupational Health team. Once submitted, 
                you cannot make changes to this health declaration.
            </div>


            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={() => onNext({})}
                    disabled={isCurrentlySubmitting}
                >
                    {isCurrentlySubmitting ? (
                        <>
                            <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                            ></span>
                            Submitting Health Declaration...
                        </>
                    ) : (
                        "Submit Health Questionnaire"
                    )}
                </button>
            </div>
        </div>
    );
}

export default StepEleven;